import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import {
  IRemitente,
  IRemitenteDestinatario,
} from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { RemitenteService } from "../../../services/catalogos/remitente/remitente.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import {
  selectCatalogoRemitenteStatus
} from "../../../states/admon-catalogos/selector";
import {
  emailPatternValidator,
  existeValorDuplicado,
  nombreRemitente
} from "../../utils";

@Component({
  selector: "app-add-remitente",
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./add-remitente.component.html",
  styleUrl: "./add-remitente.component.css",
})
export class AddRemitenteComponent {
  @Input() remitentes: IRemitenteDestinatario[] = [];
  @Output() remitentesNuevo = new EventEmitter<IRemitente>();

  private store: Store<AppState> = inject(Store);
  admonCatRemitenteStatus$ = this.store.pipe(
    select(selectCatalogoRemitenteStatus)
  );

  nuevo = false;
  descripcion = "";
  existe = false;
  nuevoRegistro!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private remitenteService: RemitenteService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.init();
  }

  init() {
    this.nuevoRegistro = this.fb.group({
      nombre: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          nombreRemitente(),
        ],
      ],
      apellido: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          nombreRemitente(),
        ],
      ],
      mail: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          emailPatternValidator(),
        ],
      ],
    });
  }
  cancelar() {
    this.init();
    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "remitentes",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  guardarRegistro() {
    this.loadingService.show();
    if (this.nuevoRegistro.valid) {
      const remitente = {
        nombre: this.nuevoRegistro.value.nombre,
        apellido: this.nuevoRegistro.value.apellido,
        mail: this.nuevoRegistro.value.mail,
      };
      this.remitenteService.guardarRemitente(remitente).then((data) => {
        this.remitentesNuevo.emit(data);
        this.loadingService.hide();
        this.cancelar();
      });
    }
  }

  existeRegistro(control: any, correoActual: any): void {
    console.log("existeRegistro control", control);
    console.log("existeRegistro cthis.remitentesontrol", this.remitentes);

    existeValorDuplicado(control, this.remitentes, correoActual);
  }
}
